import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"
import { uiColorToBaseColor } from "styleguide/styles/colors"

const DocLink = styled(Link)`
  font-size: 14px;
  line-height: 24px;
  color: ${uiColorToBaseColor("darkGray")};
  margin-left: 18px;
`

const Menu = ({ repoName }: { repoName: string }) => (
  <>
    <DocLink to="/">ShakaCode Website</DocLink>
    <DocLink to="https://forum.shakacode.com/" target="_blank" rel="noopener">
      Community
    </DocLink>
    {repoName.includes("rails") && (
      <DocLink to="/react-on-rails-pro/">React on Rails Pro</DocLink>
    )}
  </>
)

export default Menu
